'use strict';

export default function routes($routeProvider) {
  'ngInject';

  $routeProvider.when('/users', {
    template: require('./admin.html'),
    controller: 'AdminController',
    controllerAs: 'admin',
    authenticate: 'admin'
  })
  .when('/allgroups', {
    template: require('./allgroups.html'),
    controller: 'AllgroupsController',
    controllerAs: 'admin',
    authenticate: 'moderator'
  })
  .when('/passwords', {
    template: require('./passwords.html'),
    controller: 'PasswordsController',
    controllerAs: 'admin',
    authenticate: 'admin'
  });
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.routes.js